import type { ButtonHTMLAttributes, ReactNode } from "react";
import type { LucideIcon } from "lucide-react";

import { mergeClassNames } from "./classNames";
import "./controls.css";

export interface PrimaryCommandButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> {
  children: ReactNode;
  icon?: LucideIcon;
  iconPosition?: "start" | "end";
}

export function PrimaryCommandButton({
  children,
  icon: Icon,
  iconPosition = "start",
  className,
  type = "button",
  ...buttonProps
}: PrimaryCommandButtonProps) {
  return (
    <button
      {...buttonProps}
      className={mergeClassNames("ui-primary-command", className)}
      data-icon-position={iconPosition}
      type={type}
    >
      {Icon && iconPosition === "start" ? (
        <Icon aria-hidden="true" className="ui-primary-command__icon" />
      ) : null}
      <span className="ui-primary-command__label">{children}</span>
      {Icon && iconPosition === "end" ? (
        <Icon aria-hidden="true" className="ui-primary-command__icon" />
      ) : null}
    </button>
  );
}
